module.exports = __webpack_public_path__ + "assets/img/hero.231b6d6a.jpg";